var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"base-image",attrs:{"loading":_vm.loading,"decoding":_vm.decoding,"fetchpriority":_vm.fetchpriority,"src":_vm.url,"alt":_vm.alt,"title":_vm.title},on:{"load":function($event){return _vm.$emit('imageLoaded')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }